import * as Yup from 'yup';

export const noXssCharsTest = Yup.string().test(
  'no-xss-chars',
  'Cannot contain <, >, \', ", ` or & characters',
  value => {
    if (!value) return true;
    return !/[<>&'"`]/.test(value);
  },
);
